export const getLabel = <
  T extends { fullName: string; email: string; phoneNumber?: string | null }
>(
  user: T | undefined | null
) => {
  return user
    ? `${user.fullName} - ${user.email}${user.phoneNumber ? ` - ${user.phoneNumber}` : ''}`
    : ''
}
